import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class PictureService {

    getPictures(params, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/pictures',
                method: 'get',
                params: params,
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getPicture(uuid, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/pictures/' + uuid,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postPicture(picture, client, token) {
        return new Promise((done, reject) => {
            let formData = new FormData()
            formData.append("picture", picture, picture.name);
            if (client) {
                formData.append("client", client);
            }

            var instance = {
                baseURL: base + '/api/pictures',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'multipart/form-data',
                },
                data: formData
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putPicture(uuid, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/pictures/' + uuid,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deletePicture(uuid, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/pictures/' + uuid,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }


}